<script>
import { IsNullOrEmpty } from "@/modules/helper/index";
import * as Helper from '@/modules/helper/index'
import { mapGetters } from "vuex";
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    required: {
        type: Boolean,
        default: false
    },
    value: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data() {
    return {
      activeItem: '',   
      mouseOver: null,
      src: "https://craigh411.github.io/vue-rate-it/images/vueLogo.png"
    }
  },
  computed: {
    ...mapGetters([
      'AppConfig'
    ]),
    AppThemeColor() {
      return Helper.HashCodeFromInt(this.AppConfig.DesignSettings.AppThemeColor)
    },
    AppThemeFontColor() {
      return Helper.HashCodeFromInt(this.AppConfig.DesignSettings.AppThemeFontColor)
    },
    IsNullOrEmptyErrorMessage() {
        if (this.required && !IsNullOrEmpty(this.value)) {
          return true
        }
    }
  },
  methods: {
    // setRating(rating) {
    //   this.$emit('propChange', { value: rating.toString() })
    // },
    isActive(Item) {
      return this.activeItem === Item
    },
    setActive(Item) {
      this.$emit('propChange', { value: Item })
      this.activeItem = Item // no need for Vue.set()
    }
  },
};
</script>
<template>
  <f7-list class="inputs-list">
    <div class="ratingdiv" >
      <f7-label class="label-color">{{label}}</f7-label>
        <div class="row">
          <!-- Each "cell" has col-[width in percents] class -->
          <div class="col-20" :class="[ isActive('5') ? 'happy-enabled' : 'happy-disabled']" v-on:click="setActive('5')"></div>
          <div class="col-20" :class="[ isActive('4') ? 'neutral-enabled':'neutral-disabled']" v-on:click="setActive('4')"></div>
          <div class="col-20" :class="[ isActive('3') ? 'sad-enabled': 'sad-disabled']"  v-on:click="setActive('3')"></div>
          <div class="col-20" :class="[ isActive('2') ? 'slightly-happy-enabled':'slightly-happy-disabled' ]" v-on:click="setActive('2')"></div>
          <div class="col-20" :class="[ isActive('1') ? 'slightly-sad-enabled':'slightly-sad-disabled']" v-on:click="setActive('1')"></div>
       </div>
            <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
            </div>
    </f7-list>
</template>
<style scoped>
.ratingdiv {
  padding: 5px 10px;
}
.col-20 {
  height: 30px;
}
.list {
  margin: 15px 0;
}
.item-label {
 padding-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/Satisfaction.vue